// extracted by mini-css-extract-plugin
export var extra = "extra-module--extra--cccdd";
export var extra__btn = "extra-module--extra__btn--16282";
export var extra__container = "extra-module--extra__container--ffe53";
export var extra__item = "extra-module--extra__item--4fdfd";
export var extra__list = "extra-module--extra__list--4a620";
export var extra__methods = "extra-module--extra__methods--1f953";
export var extra__methodsImg = "extra-module--extra__methods-img--dfcbb";
export var extra__methodsInfo = "extra-module--extra__methods-info--ea8c6";
export var extra__methodsTxt = "extra-module--extra__methods-txt--4483e";
export var extra__methodsTxt_main = "extra-module--extra__methods-txt_main--b7330";
export var extra__text = "extra-module--extra__text--1c8e7";